export const getCoordinatorName = record => [record?.firstName, record?.lastName].filter(Boolean).join(" ");
